module.exports = __webpack_public_path__ + "static/media/GT-Haptik-Regular.96187eaf.woff2";